export default __webpack_public_path__ + "static/media/logo.690125a4.png";